import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { config } from '../config/config';
import { handleHashNavigation } from '../utils/navigation';

const Footer = () => {
  const navigate = useNavigate();

  const handlePhoneClick = () => {
    window.location.href = `tel:${config.business.contact}`;
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${config.business.email}`;
  };

  const handleSectionClick = (e, sectionId) => {
    e.preventDefault();
    handleHashNavigation(`#${sectionId}`, navigate);
  };

  const handleGetDirections = () => {
    const address = encodeURIComponent(config.business.address);
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${address}`, '_blank');
  };

  return (
    <>
      <footer>
        {/* Column 1: Company Info */}
        <div>
          <div className="flogo-container">
            <img src="/logo.jpeg" alt="JS Kuber Logo" className="flogo-img" />
            <span className="flogo-text">JS <span className="flogo-text-gold">KUBER</span></span>
          </div>
          <p className="fdesc">
            Trusted gold and silver buyer since {config.business.yearEstablished}. 
            Honest rates, instant payment, free home pickup within {config.business.homePickup.freeRadius}km.
          </p>
          <div className="fphone" onClick={handlePhoneClick} style={{ cursor: 'pointer', marginBottom: '16px' }}>
            +91-{config.business.contact}
          </div>
          {config.business.workingHours && (
            <div style={{ fontSize: '13px', color: '#666', marginBottom: '16px' }}>
              <strong>⏰ Working Hours:</strong> {config.business.workingHours}
            </div>
          )}
          <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.8' }}>
            <div><strong>📋 GSTIN:</strong> {config.business.gstin}</div>
            {config.business.ownerName && (
              <div style={{ marginTop: '6px' }}><strong>👤 Owner:</strong> {config.business.ownerName}</div>
            )}
          </div>
        </div>

        {/* Column 2: Map Section */}
        <div>
          <p className="fh" style={{ marginBottom: '16px' }}>📍 Find Us</p>
          <div style={{ 
            width: '100%', 
            height: '220px', 
            border: '2px solid var(--gold)',
            borderRadius: '4px',
            overflow: 'hidden',
            marginBottom: '12px',
            background: 'var(--light)'
          }}>
            <iframe
              title="JS Kuber Location Map"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              src={`https://www.google.com/maps?q=${encodeURIComponent(config.business.address)}&output=embed`}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <button
            onClick={handleGetDirections}
            className="btn-directions"
          >
            📍 Get Directions
          </button>
          <div style={{ 
            marginTop: '16px', 
            fontSize: '12px', 
            color: '#888',
            lineHeight: '1.6'
          }}>
            <div style={{ marginBottom: '4px' }}><strong>📍 Address:</strong></div>
            <div>{config.business.address}</div>
          </div>
        </div>

        {/* Column 3: Quick Links */}
        <div>
          <p className="fh">Services</p>
          <ul className="flinks">
            <li><a href="#services" onClick={(e) => handleSectionClick(e, 'services')}>Sell Gold</a></li>
            <li><a href="#services" onClick={(e) => handleSectionClick(e, 'services')}>Sell Silver</a></li>
            <li><a href="#services" onClick={(e) => handleSectionClick(e, 'services')}>Buy Mortgaged Gold</a></li>
          </ul>
          
          <p className="fh" style={{ marginTop: '24px' }}>Locations</p>
          <ul className="flinks">
            <li><a href="#locations" onClick={(e) => handleSectionClick(e, 'locations')}>Gurugram</a></li>
            <li><a href="#locations" onClick={(e) => handleSectionClick(e, 'locations')}>Delhi</a></li>
          </ul>
        </div>

        {/* Column 4: Contact */}
        <div>
          <p className="fh">Contact</p>
          <ul className="flinks">
            <li><a href={`tel:${config.business.contact}`} onClick={handlePhoneClick}>📞 +91-{config.business.contact}</a></li>
            <li><a href={`mailto:${config.business.email}`} onClick={handleEmailClick}>✉️ {config.business.email}</a></li>
            <li><Link to="/query">📝 Submit Query</Link></li>
            <li><Link to="/privacy-policy">🔒 Privacy Policy</Link></li>
            {/* <li><a href="#home" onClick={(e) => handleSectionClick(e, 'home')}>🏪 Visit Shop</a></li> */}
          </ul>
        </div>
      </footer>
      <div className="fcopy">
        © {new Date().getFullYear()} {config.business.legalName} | GSTIN: {config.business.gstin} | All Rights Reserved | <Link to="/privacy-policy" style={{ color: 'inherit', textDecoration: 'underline' }}>Privacy Policy</Link>
      </div>
    </>
  );
};

export default Footer;
